import React from 'react'

import SearchInput from '../../../ui/SearchInput'

import Table from '../../../components/Table'
import topVenuesModel from '../../../tables/topVenuesModel'
import { Header, Box } from '../../../ui/layout'

const TopArtists = (props) => (
  <div>
    <Header>
      <Box paddingX={2} flexGrow={1}>
        <SearchInput />
      </Box>
    </Header>
    <Table model={topVenuesModel} />
  </div>
)

export default TopArtists
